import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-900 mt-32" data-testid="site-footer">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-14 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="font-display font-black text-2xl tracking-tighter">
            BEAT-LAB <span className="text-brand-red">/</span> THE 808
          </div>
          <p className="text-ink-mute text-xs mt-4 max-w-xs leading-relaxed">
            The underground producer OS — wavetable synthesis, AI sound generation, 808 design,
            and the marketplace for the next generation of trap, rage, and drill.
          </p>
          <div className="mt-6 flex items-center gap-3 text-[10px] tracking-[0.3em] uppercase">
            <span className="px-2 py-1 border border-zinc-800 text-brand-red">v1.0.4</span>
            <span className="text-ink-dim">FL Studio · VST3 · AU · Win · macOS</span>
          </div>
        </div>
        <FooterCol title="Product" links={[
          ["Synth", "/playground"],
          ["808 Designer", "/playground#designer"],
          ["AI Presets", "/dashboard"],
          ["Pricing", "/pricing"],
        ]} />
        <FooterCol title="Producer" links={[
          ["Studio", "/dashboard"],
          ["Marketplace", "/dashboard"],
          ["Sound Packs", "/pricing"],
          ["Community", "#"],
        ]} />
        <FooterCol title="Company" links={[
          ["About", "#"],
          ["Press Kit", "#"],
          ["Support", "#"],
          ["Terms", "#"],
        ]} />
      </div>
      <div className="border-t border-zinc-900 py-5 text-center text-[10px] tracking-[0.3em] uppercase text-ink-dim">
        © 2026 BEAT-LAB — MADE LOUD IN THE UNDERGROUND
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="text-[10px] tracking-[0.3em] uppercase text-brand-red mb-4">{title}</div>
      <ul className="space-y-2.5">
        {links.map(([label, href]) => (
          <li key={label}>
            <Link to={href} className="text-xs text-ink-mute hover:text-white">
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
